import FetchService from "@/services/fetch.service";
import { isStudentLimitError, type StudentLimitError } from "@/utils/studentLimitError";

type RecursiveFetchResult = {
  success: boolean;
  count: number;
} & StudentLimitError;

export default async function recursiveFetch(
  url: string,
  method: string
): Promise<RecursiveFetchResult> {
  const res = (await FetchService.fetchData(url, method)) as {
    success: boolean;
    count?: number;
    urls?: string[];
  } & StudentLimitError;
  let success = !!res?.success;
  let count = 0;
  let studentLimitError: StudentLimitError | undefined = isStudentLimitError(res) ? res : undefined;
  if (typeof res?.count == "number") count += res.count;

  if (typeof res == "object" && "urls" in res && Array.isArray(res?.urls)) {
    for (const url of res.urls) {
      const recRes = await recursiveFetch(url, method);
      success = success && recRes.success;
      count += recRes.count;
      if (isStudentLimitError(recRes)) studentLimitError = recRes;
    }
  }
  return {
    success,
    count,
    ...(studentLimitError
      ? {
          status: studentLimitError.status,
          message: studentLimitError.message,
          error_code: studentLimitError.error_code,
          student_limit: studentLimitError.student_limit,
          active_student_count: studentLimitError.active_student_count
        }
      : {})
  };
}
